/**
 * The visit note drawn as the catalog's encounter (`#/workspace`, Antonin's list A), behind the `visitNoteV2` switch
 * (`?x=visit-note-v2`). It only sets or removes `data-visit-note-v2="on"` on the root element. Every rule of
 * `src/styles/showcase-visit-note.css` is scoped to that attribute, so with the switch off nothing changes.
 */
export function applyVisitNoteV2Look(on: boolean, root: HTMLElement = document.documentElement): void {
  if (on) root.dataset.visitNoteV2 = 'on';
  else delete root.dataset.visitNoteV2;
}
